import React from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { getE4collDmByCompany, getE4collEstablishmentsByCompany, getE4collEstablishmentsUsersByCompany, getE4collInterventionsByCompany, getE4collMaintenancesByCompany } from "../../../actions/exportData/exportData";
import StatsModal from "../../stats/StatsModal";

class CompanyExportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };
  }

  downloadFile(fileName, response) {
    let dataReceived = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(dataReceived);
    link.download = `${fileName}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  openConfModal(fileName, onExport) {
    this.setState({
      modal: (
        <StatsModal
          confirm={false}
          successCallback={() => this.onClickExport(fileName, onExport)}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  onClickExport(fileName, onExport) {
    this.setState({
      modal: <StatsModal confirm={true} close={() => this.closeModal()} />,
    });

    const successCallback = (response) => {
      this.setState({ modal: null });
      this.downloadFile(fileName, response);
    };

    onExport(this.props.company._id, successCallback);
  }

  render() {
    const linksE4COLL = [
      {
        fileName: "e4coll_etablissements",
        onExport: this.props.onGetE4collEstablishments,
        formattedMessage: "Export.Establishments",
      },
      {
        fileName: "e4coll_utilisateurs",
        onExport: this.props.onGetE4collEstablishmentsUsers,
        formattedMessage: "Export.Establishments.Users",
      },
      {
        fileName: "e4coll_parcs",
        onExport: this.props.onGetE4collDm,
        formattedMessage: "Export.Dm",
      },
      {
        fileName: "e4coll_maintenances",
        onExport: this.props.onGetE4collMaintenances,
        formattedMessage: "Export.Maintenances",
      },
      {
        fileName: "e4coll_interventions",
        onExport: this.props.onGetE4collInterventions,
        formattedMessage: "Export.Interventions",
      },
    ];

    const getLinksNode = (links) =>
      links.map((link, index) => {
        return (
          <li key={index}>
            <button
              className="btn btn-link"
              onClick={() =>
                this.openConfModal(
                  link.fileName,
                  (companyId, successCallback) =>
                    link.onExport(companyId, successCallback),
                )
              }
            >
              <FormattedMessage id={link.formattedMessage} />
            </button>
          </li>
        );
      });

    return (
      <div className="modal-bg show">
        <Modal
          show={true}
          size="lg"
          onHide={() => this.props.close()}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage id="Exporting.Data" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey="e4coll" id="exportTabs" mountOnEnter>
              <Tab eventKey="e4coll" title={"E4COLL"}>
                <div>
                  <ul style={{ listStyleType: "none" }}>
                    {getLinksNode(linksE4COLL)}
                  </ul>
                </div>
              </Tab>
              {/* <Tab eventKey="e4mad" title={"E4MAD"}></Tab>
              <Tab eventKey="e4vhp" title={"E4VHP"}></Tab> */}
            </Tabs>
            {this.state.modal}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetE4collEstablishments: (companyId, successCallback) =>
      dispatch(getE4collEstablishmentsByCompany(companyId, successCallback)),
    onGetE4collEstablishmentsUsers: (companyId, successCallback) =>
      dispatch(
        getE4collEstablishmentsUsersByCompany(companyId, successCallback),
      ),
    onGetE4collDm: (companyId, successCallback) =>
      dispatch(getE4collDmByCompany(companyId, successCallback)),
    onGetE4collInterventions: (companyId, successCallback) =>
      dispatch(getE4collInterventionsByCompany(companyId, successCallback)),
    onGetE4collMaintenances: (companyId, successCallback) =>
      dispatch(getE4collMaintenancesByCompany(companyId, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyExportModal));
